import { Typography, TextSize } from '@shared/index';
import { formatNum } from '@app/utils/math';
import { TableThead, TableTr, TableTh, Table, TableBody, TableTd } from '@widgets/table';
import ProgressBar from '@shared/uikit/progress-bar';
import { useMemo } from 'react';
import { daysUntilEndOfYear } from '@app/utils/date';
import { getCurrentDate } from '@shared/utils/getCurrentDate';
import { useGetTeamYearlyBonusResults } from '@entities/managers-perfomance';

export const YearlyTeamBonusResults = () => {
  const { year } = getCurrentDate();
  const { data: teamYearlyResults = [] } = useGetTeamYearlyBonusResults({
    year,
  });

  const { managersData, maxResult } = useMemo(() => {
    if (!teamYearlyResults.length) {
      return { managersData: [], maxResult: 1000 };
    }

    const mapped = teamYearlyResults.map(yearlyResult => ({
      id: yearlyResult.manager_id,
      name: yearlyResult.manager_name,
      result: yearlyResult.hashrate,
    }));

    const maxHashrate = Math.max(...mapped.map(hashrate => hashrate.result), 1000);

    return {
      managersData: mapped,
      maxResult: maxHashrate,
    };
  }, [teamYearlyResults]);

  const daysLeft = daysUntilEndOfYear();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <Typography size={TextSize.size24} className="font-semibold" title="Годовой бонус" />
        <div className="flex items-center gap-2 bg-[#202020] rounded-md px-2 py-1">
          <Typography size={TextSize.size10} className="text-gray-400" text="Осталось, дн" />
          <Typography size={TextSize.size12} text={daysLeft} />
        </div>
      </div>
      <div className='h-[238px] overflow-y-auto'>
        <Table>
          <TableThead className="text-white/40 [&_div]:justify-start">
            <TableTr withoutUnderline>
              <TableTh title="Менеджер" className="w-[25%]" />
              <TableTh title="Результат, Ph" className="w-[75%]" />
              <TableTh title="" className="w-[15%]" />
            </TableTr>
          </TableThead>
          <TableBody>
            {managersData.map(({ id, name, result }) => {
              const progress = (result / maxResult) * 100;
              const isReached = result >= 1000;

              return (
                <TableTr key={id} withoutUnderline>
                  <TableTd
                    title={
                      <Typography
                        size={TextSize.size12}
                        className={isReached ? 'text-white font-semibold' : 'text-white/60'}
                        text={name}
                      />
                    }
                  />
                  <TableTd
                    title={
                      <div className="flex-1 w-full">
                        <ProgressBar
                          className="h-[8px]"
                          percent={progress}
                          fillerColor={isReached ? '#71DD8C' : '#5F5F5F'}
                          backgroundColor="transparent"
                        />
                      </div>
                    }
                  />
                   <TableTd
                    title={
                      <Typography
                        size={TextSize.size12}
                        className={isReached ? 'text-green-200' : 'text-white/60'}
                        text={formatNum(result)}
                      />
                    }
                  />
                </TableTr>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
